import React, { useState } from "react";
import { Form, Button, Modal } from "react-bootstrap";

export const GuestForm = ({ idx, updateGuest, formSubmitClicked }) => {
  const [name, _setName] = useState(""),
    [showWarningModal, setShowWarningModal] = useState(false);

  const setName = (val) => {
    const nextName = String(val || "");
    _setName(nextName);
    updateGuest(idx, { name: nextName }, false);
  };

  const handleChange = (val) => {
    setName(val);
  };

  const removeGuest = () => {
    const currentName = name;
    _setName("");
    updateGuest(idx, { name: currentName }, true);
  };

  const guestNameIsBlank = name.trim() === "";

  return (
    <div className="mt-2 ">
      <div
        className="position-relative d-flex align-items-stretch"
        style={{ gap: ".5rem" }}
      >
        <Form.Group controlId={`guest_name_${idx}`} style={{ flexGrow: 1 }}>
          <Form.Control
            value={name}
            required
            onChange={(e) => {
              handleChange(e.target.value);
            }}
            onBlur={(e) => {
              handleChange(e.target.value);
            }}
            placeholder="Guest Name"
            className={"nf-sans-cond"}
          />
        </Form.Group>

        <div style={{ display: "flex", alignItems: "stretch" }}>
          <Button
            type="button"
            className="rsvp-button "
            onClick={() => {
              setShowWarningModal(true);
            }}
          >
            Remove
          </Button>
        </div>
      </div>

      {formSubmitClicked && guestNameIsBlank ? (
        <div className="validation__message mt-2">
          Please enter the guest's name
        </div>
      ) : (
        ""
      )}

      <Modal
        show={showWarningModal}
        onHide={() => {
          setShowWarningModal(false);
        }}
        size="lg"
        dialogClassName="event__modal-new eventmodal__container"
        centered={true}
      >
        <div
          style={{
            flexGrow: 1,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}
        >
          <div
            className="my-4 text-center text-uppercase font-weight-bold nf-sans-cond"
            style={{ fontSize: "1.5rem", color: "#fff" }}
          >
            Are you sure you want to remove this guest?
          </div>
          <div className="justify-content-center mb-4 d-flex">
            <Button
              type="button"
              className="rsvp-button white-button nf-sans-cond"
              onClick={() => {
                setShowWarningModal(false);
                removeGuest();
              }}
            >
              Yes
            </Button>
            <Button
              type="button"
              className="ms-2 rsvp-button white-button nf-sans-cond"
              onClick={() => {
                setShowWarningModal(false);
              }}
            >
              No
            </Button>
          </div>
        </div>
      </Modal>
    </div>
  );
};
